import { defineStore } from 'pinia'

import state from './client.state'
import actions from './client.actions'

/**
 * Returns the client store
 */
export const useClientStore = defineStore('client', {
  state: () => state,
  actions
})
